import React from 'react';
import { mapModifiers } from 'libs/component';
import { Icon } from 'components/atoms/icon';

export interface ContactInfoHeaderProps {
  icon: string;
  children?: React.ReactNode;
}

export const ContactInfoHeader: React.FC<ContactInfoHeaderProps> = ({ icon, children }) => (
  <h3 className={mapModifiers('a-contact-info-header')}>
    <span className="a-contact-info-header__icon">
      <Icon name={icon} color="gold" />
    </span>
    {children}
  </h3>
);
